import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileEventsConfig } from '@v2/pages/nc-file/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsNCFileEventsStack = createStackNavigator();

const NCFileDetailsNCFileEventsNavigator = (props: any) => {
  return (
    <NCFileDetailsNCFileEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileEventsConfig.map(({ Component, name }) => (
        <NCFileDetailsNCFileEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </NCFileDetailsNCFileEventsStack.Navigator>
  );
};

export { NCFileDetailsNCFileEventsNavigator };
